module.exports = __webpack_public_path__ + "img/4.fd6ca17e.jpg";